export var GooglePayCardAuthMethod;
(function (GooglePayCardAuthMethod) {
    GooglePayCardAuthMethod["PAN_ONLY"] = "PAN_ONLY";
    GooglePayCardAuthMethod["CRYPTOGRAM_3DS"] = "CRYPTOGRAM_3DS";
})(GooglePayCardAuthMethod || (GooglePayCardAuthMethod = {}));
//# sourceMappingURL=googlepay-payment-method-options.js.map